import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=53527a9f&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53527a9f')) {
      api.createRecord('53527a9f', component.options)
    } else {
      api.reload('53527a9f', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=53527a9f&", function () {
      api.rerender('53527a9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SwBIqHg4LGK4/JS/videoIframe.vue"
export default component.exports